import { render, staticRenderFns } from "./PoiCategoriesSettings.vue?vue&type=template&id=36f6a484&scoped=true"
import script from "./PoiCategoriesSettings.vue?vue&type=script&lang=js"
export * from "./PoiCategoriesSettings.vue?vue&type=script&lang=js"
import style0 from "./PoiCategoriesSettings.vue?vue&type=style&index=0&id=36f6a484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f6a484",
  null
  
)

export default component.exports